var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-time-picker',_vm._b({attrs:{"format":"HH:mm"},on:{"change":_vm.onTimeChange},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'el-time-picker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }